import { GridProps } from '@chakra-ui/react';
import {
  ContentsApiResponse,
  mapApiSearchContentResultsFromApiToVm,
} from '~/searchApi';

import { usePageBuilderStore } from '../../hooks/usePageBuilderStore';
import { AnyBlock } from '../../types';
import { DraggableContent } from './DraggableContent';
import { ReorderGrid } from './ReorderGrid/ReorderGrid';

export interface TalentContentProperties {
  creatorId: string;
  customContent: ContentsApiResponse['results'];
}

interface Props extends TalentContentProperties {
  blockId: string;
}

export const talentContentGridProps: GridProps = {
  as: 'section',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  rounded: 12,
  gap: 4,
  overflowX: 'auto',
  css: {
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
  },
};

export const TalentContent: React.FC<Props> = ({ blockId }: Props) => {
  const { blocks, updateBlock } = usePageBuilderStore();
  const block = blocks.find((b) => b.id === blockId) as AnyBlock | undefined;

  // Guard clause for missing block
  if (!block) {
    // eslint-disable-next-line no-console
    console.error(`Block with id ${blockId} not found`);
    return null;
  }

  const items = (block.properties as TalentContentProperties).customContent;
  const setItems = (newItems: ContentsApiResponse['results']) => {
    updateBlock(blockId, {
      ...block,
      properties: {
        ...(block.properties as TalentContentProperties),
        customContent: newItems,
      },
    } as AnyBlock);
  };

  const mappedContent = mapApiSearchContentResultsFromApiToVm(items);

  return (
    <ReorderGrid
      values={items}
      onReorder={setItems}
      {...talentContentGridProps}
    >
      {mappedContent.map((content, index) => (
        <DraggableContent
          key={content.contentId}
          content={content}
          index={index}
          items={items}
          blockId={blockId}
        />
      ))}
    </ReorderGrid>
  );
};
